import React from 'react';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, parseQuery } from '@jjj/components';
import { t } from '../../../i18n';
import { getFormattedDate } from '../../../helpers/dateTime';
import { CompanyAvatarWrapper, LoadMoreJobsBtnWrapper, SmallCompanyAvatarWrapper } from './columns.styles';

export const JOBS_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export function getLogoByOrganization(organization, isSmall = false) {
  const { name, logo } = organization;

  if (isSmall) {
    return <SmallCompanyAvatarWrapper src={logo} alt={`logo-${name}`} />;
  }

  return <CompanyAvatarWrapper src={logo} alt={`logo-${name}`} />;
}

export function getJobFormattedDate(job) {
  if (job.starts_at || job.finishes_at) {
    if (!job.multi_day) {
      return getFormattedDate({ date: job.starts_at || job.finishes_at, formatKey: 'date_numeric_long' });
    }

    const startDateFormatted = getFormattedDate({ date: job.starts_at, formatKey: 'date_day_month' });
    const finishDateFormatted = getFormattedDate({ date: job.finishes_at, formatKey: 'date_numeric_long' });

    return `${startDateFormatted} - ${finishDateFormatted}`;
  }
}

export function loadMoreJobsButton({ onClick }) {
  return (
    <LoadMoreJobsBtnWrapper>
      <Button
        type="link"
        className="load-more-button"
        onClick={onClick}
        size="small"
        data-cy="jobs-load-more-jobs-button"
      >
        <FontAwesomeIcon icon="ellipsis-h" className="load-more-button-icon" />
        {t('dash.common.button.load_more_label')}
      </Button>
    </LoadMoreJobsBtnWrapper>
  );
}

export function getJobsListPageTitle(jobs, search) {
  const isMultiDayView = search.includes('job_group_id=');

  if (jobs && isMultiDayView) {
    const [multiDayJob] = jobs.filter(job => job.job_group_id !== null);

    if (multiDayJob) {
      return (
        <Helmet defer={false}>
          <title>{multiDayJob.company_name}</title>
        </Helmet>
      );
    }
  }

  return null;
}

export function getJobsListRedirectUrl(record, search, key) {
  const { worker_id, company_id } = parseQuery(search);

  if (record.isLoadMoreRow) {
    return '';
  }

  if (record.multi_day) {
    if (worker_id || company_id) {
      return `/jobs/multiDay?tab=${key}&job_group_id=${record.job_group_id}&noRedirect=true`;
    }

    return `/jobs/multiDay?tab=${key}&job_group_id=${record.job_group_id}`;
  }

  if (!record.multi_day && record.job_group_id) {
    return `/jobs/multiDay/${record.id}?tab=bookings`;
  }

  if (!record.multi_day) {
    return `/jobs/${record.id}?tab=bookings`;
  }
}

export const getJobStatusTitle = job => {
  const options = { count: job?.status?.pending_shifts_count };

  return t(`dash.jobs.statuses.${job?.status?.id}`, options, job?.status?.name || job?.status || '');
};
